<template>
    <!-- <avatar :fullname="scrubName(name)" :color="color" :size="size" :image="photoUrl"></avatar> -->
    <b-avatar v-show="name" class="fix-padding-bug avatar-component" :style="{ 'background-color': computedColor + '!important' }" rounded="circle" :text="computedInitials" :color="computedColor" :size="size" :src="photoUrl"> </b-avatar>
</template>

<script lang="ts">
import { defineComponent } from "vue";
// import Avatar from "vue-avatar-component";
import Utils from "@/util/Utils";
import { UserColors } from "@/data/UserColors";

export default defineComponent({
    name: "AvatarView",
    components: {
        // Avatar,
    },
    mixins: [Utils],
    props: {
        name: {
            type: String,
            required: true,
        },
        photoUrl: String,
        size: {
            type: Number,
            default: 40,
        },
    },
    computed: {
        computedColor(): string {
            if (!this.name) return UserColors.gray;
            if (this.photoUrl) return "transparent";

            const utf8 = this.name.split("").map((c) => c.charCodeAt(0));
            const hash = utf8.reduce((acc, curr) => ((acc << 5) + acc + curr) & 0xffffffff, 5381);
            const cases = Object.values(UserColors);
            const idx = Math.abs(hash) % cases.length;
            return cases[idx];
        },
        computedInitials(): string {
            if (!this.name) return "";
            if (this.photoUrl) return "";

            return this.scrubName(this.name)
                .toUpperCase()
                .split(" ")
                .filter((word) => word.length > 0)
                .map((word) => word[0])
                .slice(0, 2)
                .join("");
        },
    },
    methods: {
        initials(): string {
            return this.scrubName(this.name!)
                .toUpperCase()
                .split(" ")
                .filter((word) => word.length > 0)
                .map((word) => word[0])
                .slice(0, 2)
                .join("");
        },
    },
});
</script>

<style scoped>
h6 {
    margin: 0;
    font-weight: bold;
}

.thumbnail {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}
.grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(100px, 1fr));
}

.grid > div {
    /* background: black; */
    padding: 1px;
    display: grid;
}

.grid > div::before {
    content: "";
    padding-bottom: 100%;
    display: block;
}

.grid > div::before,
.grid > div > div {
    grid-area: 1 / 1 / 2 / 2;
}

.avatar-style {
    background-color: blue !important;
}

.fix-padding-bug {
    --bs-gutter-x: 0;
}

.avatar-component {
    transition: background-color 0.2s ease-in-out;
}

.avatar-component img {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.avatar-component img.loaded {
    opacity: 1;
}
</style>
